const isObject = (value: unknown): value is object => Object(value) === value;

export const toUrlParams = <T extends Record<string, any>>(request: T): string => {
  return Object.keys(request ?? {})
    .filter((key) => request[key] !== undefined)
    .map((key) => {
      const value = request[key];
      return `${encodeURIComponent(key)}=${encodeURIComponent(isObject(value) ? JSON.stringify(value) : value)}`;
    })
    .join("&");
};

export const fromUrlParams = <T extends Record<string, any>>(params: string): T => {
  const entries = new URLSearchParams(params);
  const results: Record<string, any> = {};

  for (const [key, value] of entries) {
    if (!results[key]) {
      results[key] = value;
    } else if (Array.isArray(results[key])) {
      results[key] = [...results[key], value];
    } else {
      results[key] = [results[key], value];
    }
  }

  return results as T;
};
